// Mock data for F.L.Y Entertainment website
export const LOGO_URL = 'https://customer-assets.emergentagent.com/job_907c8ac4-b4c8-435e-9d38-16d389643ce7/artifacts/qwzx2qry_F.L.Y%20LOGO.jpg';

export const HERO_IMAGES = [
  'https://images.pexels.com/photos/13230484/pexels-photo-13230484.jpeg',
  'https://images.unsplash.com/photo-1540039155733-5bb30b53aa14',
  'https://images.pexels.com/photos/36675302/pexels-photo-36675302.jpeg',
];

export const SECTION_IMAGES = {
  studio: 'https://images.unsplash.com/photo-1514320291840-2e0a9bf2a9ae',
  office: 'https://images.pexels.com/photos/14711251/pexels-photo-14711251.jpeg',
  album: 'https://images.unsplash.com/photo-1642444525640-d3eb287ed389',
  crowd: 'https://images.unsplash.com/photo-1540039155733-5bb30b53aa14',
  stage: 'https://images.pexels.com/photos/13230484/pexels-photo-13230484.jpeg',
};

// 7 members of the flagship group ASCEND
export const ARTISTS = [
  {
    id: 'jinho',
    stageName: 'JIN-HO',
    realName: 'Kim Jin-Ho',
    role: 'Leader • Main Vocalist',
    birth: '1997.03.12',
    color: '#FF6B1A',
    image: 'https://images.unsplash.com/photo-1730328300093-f85a92502ea2',
    bio: 'The guiding light of ASCEND. Jin-Ho leads the group with a soaring vocal range and a calm, unshakable presence both on and off stage.',
    mbti: 'INFJ',
    position: 'Leader, Vocal',
    songs: ['Skybound', 'Prism', 'Into The Night'],
  },
  {
    id: 'kaien',
    stageName: 'KAI-EN',
    realName: 'Park Kai-En',
    role: 'Main Rapper • Producer',
    birth: '1998.07.24',
    color: '#A855F7',
    image: 'https://images.unsplash.com/photo-1617355453845-6996ffeee4de',
    bio: 'The sonic architect of the group. Kai-En writes, produces and delivers razor-sharp verses that define ASCEND\'s signature sound.',
    mbti: 'ENTP',
    position: 'Main Rapper, Producer',
    songs: ['Altitude', 'Neon Rush', 'Velocity'],
  },
  {
    id: 'luna',
    stageName: 'LUNA',
    realName: 'Lee Han-Sol',
    role: 'Lead Vocalist',
    birth: '1999.01.09',
    color: '#00E5E5',
    image: 'https://images.pexels.com/photos/10686007/pexels-photo-10686007.jpeg',
    bio: 'Known for emotional depth and crystalline tone, Luna\'s voice carries ASCEND\'s most heartfelt moments.',
    mbti: 'ISFP',
    position: 'Lead Vocal',
    songs: ['Moonlight', 'Paperboat', 'Orbit'],
  },
  {
    id: 'zen',
    stageName: 'ZEN',
    realName: 'Choi Do-Yun',
    role: 'Main Dancer • Vocalist',
    birth: '1999.09.18',
    color: '#3B82F6',
    image: 'https://images.pexels.com/photos/29145002/pexels-photo-29145002.jpeg',
    bio: 'Every stage belongs to Zen. A master of precision choreography and quiet charisma that fills an arena.',
    mbti: 'ISTP',
    position: 'Main Dancer',
    songs: ['Gravity', 'Waveform', 'Silhouette'],
  },
  {
    id: 'ravi',
    stageName: 'RAVI',
    realName: 'Jung Min-Jae',
    role: 'Lead Rapper • Dancer',
    birth: '2000.05.02',
    color: '#FF6B1A',
    image: 'https://images.pexels.com/photos/8656991/pexels-photo-8656991.jpeg',
    bio: 'Sharp flow, explosive energy. Ravi brings the fire that pushes every ASCEND performance over the edge.',
    mbti: 'ESTP',
    position: 'Lead Rapper, Dancer',
    songs: ['Ignite', 'Blackout', 'Skyline'],
  },
  {
    id: 'sho',
    stageName: 'SHO',
    realName: 'Han Sung-Min',
    role: 'Sub Vocalist • Visual',
    birth: '2000.11.27',
    color: '#A855F7',
    image: 'https://images.pexels.com/photos/4041087/pexels-photo-4041087.jpeg',
    bio: 'Magnetic stage presence and a silky-smooth tone. Sho is the visual heart of ASCEND.',
    mbti: 'INFP',
    position: 'Sub Vocal, Visual',
    songs: ['Silk', 'Afterglow', 'Mirage'],
  },
  {
    id: 'aris',
    stageName: 'ARIS',
    realName: 'Yoon Ji-Ho',
    role: 'Maknae • Dancer',
    birth: '2002.04.15',
    color: '#00E5E5',
    image: 'https://images.pexels.com/photos/33151699/pexels-photo-33151699.jpeg',
    bio: 'The youngest member, but never the smallest energy on stage. Aris brings the bright, electric spark.',
    mbti: 'ENFP',
    position: 'Dancer, Vocal',
    songs: ['Supernova', 'Tiny Planet', 'Bloom'],
  },
];

export const GROUPS = [
  {
    id: 'ascend',
    name: 'ASCEND',
    tagline: '7 voices. One sky.',
    debut: '2021',
    members: 7,
    image: 'https://images.pexels.com/photos/13230484/pexels-photo-13230484.jpeg',
    accent: '#FF6B1A',
  },
  {
    id: 'skyline',
    name: 'SKYLINE',
    tagline: 'Sub-unit. Dual vocals, endless horizon.',
    debut: '2023',
    members: 2,
    image: 'https://images.unsplash.com/photo-1540039155733-5bb30b53aa14',
    accent: '#00E5E5',
  },
  {
    id: 'nova',
    name: 'NOVA',
    tagline: 'Solo project. A star reborn.',
    debut: '2024',
    members: 1,
    image: 'https://images.unsplash.com/photo-1642444525640-d3eb287ed389',
    accent: '#A855F7',
  },
];

// YouTube video IDs — used for in-app YouTube viewer (mocked MV catalogue)
export const VIDEOS = [
  {
    id: 'v1',
    title: 'ASCEND — SKYBOUND (Official MV)',
    artist: 'ASCEND',
    youtubeId: '3MjdoaTLBNk',
    thumb: 'https://images.pexels.com/photos/13230484/pexels-photo-13230484.jpeg',
    tag: 'Title Track',
  },
  {
    id: 'v2',
    title: 'ASCEND — NEON RUSH (Performance Ver.)',
    artist: 'ASCEND',
    youtubeId: 'gdZLi9oWNZg',
    thumb: 'https://images.unsplash.com/photo-1540039155733-5bb30b53aa14',
    tag: 'Performance',
  },
  {
    id: 'v3',
    title: 'SKYLINE — MOONLIGHT (Official MV)',
    artist: 'SKYLINE',
    youtubeId: 'WMweEpGlu_U',
    thumb: 'https://images.unsplash.com/photo-1642444525640-d3eb287ed389',
    tag: 'Sub-unit',
  },
  {
    id: 'v4',
    title: 'NOVA — SUPERNOVA (Visualizer)',
    artist: 'NOVA',
    youtubeId: 'V_MXGdSBbAI',
    thumb: 'https://images.unsplash.com/photo-1514320291840-2e0a9bf2a9ae',
    tag: 'Solo',
  },
  {
    id: 'v5',
    title: 'ASCEND — VELOCITY (Dance Practice)',
    artist: 'ASCEND',
    youtubeId: 'pBk4NYhWNMM',
    thumb: 'https://images.pexels.com/photos/36675302/pexels-photo-36675302.jpeg',
    tag: 'Dance Practice',
  },
  {
    id: 'v6',
    title: 'ASCEND — PRISM (Official MV)',
    artist: 'ASCEND',
    youtubeId: 'H4uoH1vgQFE',
    thumb: 'https://images.unsplash.com/photo-1540039155733-5bb30b53aa14',
    tag: 'Title Track',
  },
];

export const NEWS = [
  {
    id: 'n1',
    category: 'ARTIST',
    date: '2025.07.18',
    title: 'ASCEND announces 3rd full-length album \'ALTITUDE\' — releasing September 12',
    excerpt: 'F.L.Y Entertainment confirms the long-awaited return of ASCEND with their most ambitious album to date.',
    image: 'https://images.pexels.com/photos/13230484/pexels-photo-13230484.jpeg',
  },
  {
    id: 'n2',
    category: 'COMPANY',
    date: '2025.07.10',
    title: 'F.L.Y Entertainment opens new creative campus in Seoul',
    excerpt: 'A 14-floor hub for training, production and global A&R goes live this summer.',
    image: 'https://images.pexels.com/photos/14711251/pexels-photo-14711251.jpeg',
  },
  {
    id: 'n3',
    category: 'TOUR',
    date: '2025.07.02',
    title: 'ASCEND WORLD TOUR \'SKYBOUND\' — dates announced across 4 continents',
    excerpt: '24 cities. 36 shows. The biggest F.L.Y tour ever begins this October.',
    image: 'https://images.unsplash.com/photo-1540039155733-5bb30b53aa14',
  },
  {
    id: 'n4',
    category: 'MUSIC',
    date: '2025.06.24',
    title: 'NOVA drops surprise single \'SUPERNOVA\' — tops global charts',
    excerpt: 'The solo debut smashes streaming records in its opening week.',
    image: 'https://images.unsplash.com/photo-1642444525640-d3eb287ed389',
  },
  {
    id: 'n5',
    category: 'ARTIST',
    date: '2025.06.15',
    title: 'SKYLINE releases cinematic short film for \'MOONLIGHT\'',
    excerpt: 'The sub-unit\'s latest visual pushes K-pop storytelling into new territory.',
    image: 'https://images.unsplash.com/photo-1514320291840-2e0a9bf2a9ae',
  },
  {
    id: 'n6',
    category: 'COMPANY',
    date: '2025.06.01',
    title: 'F.L.Y Entertainment reports record H1 2025 revenue',
    excerpt: 'Global expansion and artist IP drive a 42% YoY increase.',
    image: 'https://images.pexels.com/photos/14711251/pexels-photo-14711251.jpeg',
  },
];

export const CAREERS = [
  { id: 'c1', dept: 'A&R', title: 'Senior A&R Manager — Global Pop', location: 'Seoul, KR', type: 'Full-time' },
  { id: 'c2', dept: 'Creative', title: 'Music Video Director', location: 'Seoul, KR', type: 'Full-time' },
  { id: 'c3', dept: 'Marketing', title: 'Global Social Media Lead', location: 'Los Angeles, US', type: 'Full-time' },
  { id: 'c4', dept: 'Technology', title: 'Senior Frontend Engineer — Weverse-style Platform', location: 'Seoul, KR', type: 'Full-time' },
  { id: 'c5', dept: 'Artist Management', title: 'Tour Operations Manager', location: 'Tokyo, JP', type: 'Full-time' },
  { id: 'c6', dept: 'Design', title: 'Brand & Packaging Designer', location: 'Seoul, KR', type: 'Contract' },
  { id: 'c7', dept: 'Business', title: 'Global Business Development Lead', location: 'Remote', type: 'Full-time' },
  { id: 'c8', dept: 'Creative', title: 'Choreography Director', location: 'Seoul, KR', type: 'Full-time' },
];

export const STATS = [
  { label: 'Artists under label', value: '12+' },
  { label: 'Global monthly listeners', value: '68M' },
  { label: 'Tour cities 2024–25', value: '48' },
  { label: 'Awards won', value: '120+' },
];

export const TIMELINE = [
  { year: '2018', title: 'F.L.Y Entertainment founded', text: 'A small studio in Seoul with a big ambition — reshape global pop music.' },
  { year: '2020', title: 'First trainee class debuts', text: 'The foundation of what would become ASCEND.' },
  { year: '2021', title: 'ASCEND debuts with \'Skybound\'', text: 'Top 5 in 14 countries within the first week.' },
  { year: '2023', title: 'Sub-unit SKYLINE launches', text: 'A new chapter of experimental R&B-pop.' },
  { year: '2024', title: 'NOVA solo project', text: 'F.L.Y\'s first billion-stream solo release.' },
  { year: '2025', title: 'Global campus & world tour', text: 'F.L.Y goes truly global — 4 continents, 1 sky.' },
];
